// @flow
import {
    GET_NATURE_TYPES,
    GET_NETWORK_TYPES,
    GET_STRUCTURE_TYPES,
    GET_REGIONS,
    GET_DEPARTMENTS,
    EVENT_DATA_LOADING,
    EVENT_DATA_ERROR,
} from "../actions/constants";
import type { Actions } from "../actions/actions";
import type { NatureType } from "../entities/natureType.type";
import type { NetworkType } from "../entities/networkType.type";
import type { StructureType } from "../entities/structureType.type";
import type { Region } from "../entities/region.type";
import type { Department } from "../entities/department.type";

export type TypeState = {|
    natureTypes: Array<NatureType>,
    networkTypes: Array<NetworkType>,
    structureTypes: Array<StructureType>,
    departments: Array<Department>,
    regions: Array<Region>,
    loading: boolean,
    error: boolean,
|};

const initialState = {
    natureTypes: [],
    networkTypes: [],
    structureTypes: [],
    departments: [],
    regions: [],
    loading: true,
    error: false,
};

function typeReducer(state: TypeState = initialState, action: Actions) {
    if (action.type === GET_NATURE_TYPES) {
        return { ...state, natureTypes: action.payload };
    }

    if (action.type === GET_NETWORK_TYPES) {
        return { ...state, networkTypes: action.payload };
    }

    if (action.type === GET_STRUCTURE_TYPES) {
        return { ...state, structureTypes: action.payload };
    }

    if (action.type === GET_REGIONS) {
        return { ...state, regions: action.payload };
    }

    if (action.type === GET_DEPARTMENTS) {
        return { ...state, departments: action.payload };
    }

    if (action.type === EVENT_DATA_LOADING) {
        return { ...state, loading: action.payload.loading };
    }

    if (action.type === EVENT_DATA_ERROR) {
        return { ...state, error: action.payload.error };
    }

    return state;
}

export default typeReducer;
